import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { Injectable } from '@angular/core'
import { Apollo } from 'apollo-angular'
import {
    EventFragment,
    EventQuery,
    EventQueryService,
    EventQueryVariables,
    EventsQuery,
    EventsQueryService,
    EventsQueryVariables,
    LocalesEnum,
    Maybe,
} from '@app-graphql/schema'

@Injectable({
    providedIn: 'root',
})
export class EventsService {

    constructor(
        private eventQueryService: EventQueryService,
        private eventsQueryService: EventsQueryService,
    ) {
    }

    public getEvent(input: EventQueryVariables): Observable<Apollo.QueryResult<EventQuery>> {
        return this.eventQueryService.fetch({ variables: input })
    }

    public getEvents(input: EventsQueryVariables): Observable<Apollo.QueryResult<EventsQuery>> {
        return this.eventsQueryService.fetch({ variables: input })
    }

    public getEventBySlug(slug: string, locale: string): Observable<Maybe<EventFragment> | undefined> {
        return this.getEvent({ slug: slug, locale: locale as LocalesEnum }).pipe(
            map((event) => event.data?.event),
        )
    }

}
